import { useState } from "react";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordInput = ({
  name,
  value,
  onChange,
  error,
  placeholder,
  fullWidth = true,
  gradient = true,
  sx,
}) => {
  const [show, setShow] = useState(false);

  return (
    <VuiBox position="relative">
      <VuiInput
        gradient={gradient}
        fullWidth={fullWidth}
        type={show ? "text" : "password"}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        placeholder={placeholder}
        sx={{ pr: "42px", ...sx }}
        inputProps={{ maxLength: 300 }}
      />

      <VuiBox
        position="absolute"
        top="20%"
        right="18px"
        transform="translateY(-50%)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={() => setShow((prev) => !prev)}
        sx={{
          cursor: "pointer",
          color: "rgba(255,255,255,0.7)",
          "&:hover": { color: "#fff" },
        }}
      >
        <VuiBox sx={{ fontSize: "16px", color: "rgba(255,255,255,0.7)" }}>
          {show ? <FaEyeSlash /> : <FaEye />}
        </VuiBox>
      </VuiBox>
    </VuiBox>
  );
};

export default PasswordInput;
